








import Vue from 'vue';
import Component from "vue-class-component";
import EventApi from "../../api/EventsApi";

type SoundObj = {
    id: string,
    isTheme: boolean,
    hasLoop: boolean
}

@Component({})

export default class SoundsContainer extends Vue {
    private allowSystemSound: boolean = true;
    private allowSystemTableSound: boolean = true;
    private themeIsPlaying: boolean = false;
    private currentTheme: SoundObj|null = null;
    private themeIsLooping: boolean = false;

    private themeSoundHolder: HTMLAudioElement|null = null;
    private systemSoundHolder: HTMLAudioElement|null = null;
    private tableSystemSoundHolder: HTMLAudioElement|null = null;

    /**
     * Зацикленные звуки
     * @private
     */
    private loopsIds = [
        'mafiaDayLoop',
        'mafiaNightLoop'
    ];

    /**
     * Звуки темы
     * @private
     */
    private themeSounds = [
        'mafiaDayBegin',
        'mafiaDayLoop',
        'mafiaNightBegin',
        'mafiaNightLoop',
        'mafiaEndGameCitizens',
        'mafiaEndGameMafia',
        'mafiaMafiaHit',
        'mafiaCitizenExecuted',
    ];

    /**
     * Победные темы и звуки, которые должны сохраниться при очищении очереди при окончании игры
     * @private
     */
    private winThemes = [
        'mafiaEndGameMafia',
        'mafiaEndGameCitizens',
        'mafiaMafiaHit',
        'mafiaCitizenExecuted'
    ];

    private breakLoopImmediately = [
        'mafiaCitizenExecuted'
    ];

    /**
     * Звуки начала нового раунда
     * @private
     */
    private newRoundThemes = [
        'mafiaDayBegin'
    ];

    /**
     * Звуки окончания игры
     * @private
     */
    private endGameThemes = [
        'mafiaEndGameMafia',
        'mafiaEndGameCitizens',
        'gameEndSimiloWin',
        'gameEndSimiloLoose'
    ];

    /**
     * Системные звуки стола
     * @private
     */
    private tableSystemSounds = [
        'click',
        'flip',
        'addToPile',
        'select',
        'itemMovedToTable',
        'zoom',
        'shuffle',
        'dealSeveralCards',
        'itemSended',
        'itemReceived',
        'itemLock',
        'itemUnlock',
        'error',
        'itemTakeToHand',
        'delete',
        'zoomIn',
        'zoomOut'
    ];

    private themeSoundsQueue: Array<SoundObj> = [];

    private gameIsFinished: boolean = false;

    mounted(): void
    {
        this.$nextTick(() => {
            this.themeSoundHolder = this.$refs.themeSound as HTMLAudioElement;
            this.systemSoundHolder = this.$refs.systemSound as HTMLAudioElement;
            this.tableSystemSoundHolder = this.$refs.tableSystemSound as HTMLAudioElement;

            this.themeSoundHolder.addEventListener('ended', () => {
                this.themeIsPlaying = false;
            });
        });

        EventApi.addEventListener(EventApi.RESET_AUDIO_THEME, () => {
            this.resetTheme(true);
        });
        EventApi.addEventListener(EventApi.START_SOUND, (e) => {
            const soundData: {sound: string} = (e as CustomEvent).detail;
            const soundId = soundData.sound;
            const isThemeSound = this.themeSounds.includes(soundId);
            const isTableSystemSound = this.tableSystemSounds.includes(soundId);

            this.$nextTick(() => {
                if (isThemeSound) {
                    this.addSoundToQueue({
                        id: soundId,
                        isTheme: isThemeSound,
                        hasLoop: this.loopsIds.includes(soundId)
                    });
                    if (this.themeIsPlaying) {
                        // если игра закончена
                        if (this.endGameThemes.includes(soundId)) {
                            this.resetTheme(false);
                            this.themeSoundsQueue = this.themeSoundsQueue
                                .filter(sound => this.winThemes.includes(sound.id));
                            this.gameIsFinished = true;
                            this.playThemeSound(this.themeSoundsQueue[0].id);
                        }
                        // если новый раунд
                        else if (this.newRoundThemes.includes(soundId)) {
                            this.themeSoundsQueue = this.themeSoundsQueue
                                .filter(sound => this.newRoundThemes.includes(sound.id));
                            this.playThemeSound(this.themeSoundsQueue[0].id);
                        } else if (this.breakLoopImmediately.includes(soundId)) {
                            this.playThemeSound(soundId);
                        } else {
                            this.playNextThemeSound(this.themeIsPlaying && this.themeIsLooping && !this.loopsIds.includes(soundId));
                        }
                    } else {
                        this.playThemeSound(soundId);
                    }
                } else if (isTableSystemSound) {
                    this.playSystemSound(soundId, this.tableSystemSoundHolder, this.allowSystemTableSound, true);
                } else {
                    this.playSystemSound(soundId, this.systemSoundHolder as HTMLAudioElement, this.allowSystemSound);
                }
            });
        });
    }

    private resetTheme(clearQueue: boolean): void
    {
        const audio = this.themeSoundHolder as HTMLAudioElement;
        audio.pause();
        audio.currentTime = 0;
        this.themeIsPlaying = false;
        this.themeIsLooping = false;
        this.currentTheme = null;
        if (clearQueue) {
            this.themeSoundsQueue = [];
        }
    }

    /**
     * Добавить звук в очередь
     * @param sound
     * @private
     */
    private addSoundToQueue(sound: SoundObj): void
    {
        if (sound.isTheme) {
            this.themeSoundsQueue.push(sound);
        }
    }


    private getSoundById(id: string): SoundObj|null
    {
        const filtered = this.themeSoundsQueue.filter(sound => sound.id === id);

        if (typeof filtered[0] !== 'undefined') {
            return filtered[0];
        }
        return null;
    }

    /**
     * Приглушить текущую тему
     * @private
     */
    private fadeOutSoundTheme(breakLoop: boolean): Promise<void>
    {
        return new Promise((resolve, reject) => {
            const audio = this.themeSoundHolder as HTMLAudioElement;
            const fade = () => {
                const fadePoint = audio.duration - 1;
                const fadeAudio = setInterval(() => {

                    if (breakLoop) {
                        audio.volume -= 0.1;
                    } else {
                        if ((audio.currentTime >= fadePoint) && (+audio.volume.toFixed(1) > 0.1)) {
                            audio.volume -= 0.1;
                        }
                    }

                    if (+audio.volume.toFixed(1) <= 0.1) {
                        clearInterval(fadeAudio);
                        resolve();
                    }
                }, 100);
            };
            fade();
        });
    }

    private stopThemeSound(): void
    {
        this.themeIsPlaying = false;
        this.themeIsLooping = false;
        this.currentTheme = null;
        const audio = this.themeSoundHolder as HTMLAudioElement;
        audio.pause();
        audio.currentTime = 0;
        audio.src = '';
    }

    private deleteThemeSoundFromQueue(): Promise<void>
    {
        return new Promise((resolve, reject) => {
            if (this.themeSoundsQueue.length) {
                this.themeSoundsQueue.shift();
            }
            resolve();
        });
    }

    private playNextThemeSound(breakLoop: boolean = false): void
    {
        const fade = (beakLoop: boolean) => this.fadeOutSoundTheme(beakLoop).then(() => {
            this.stopThemeSound();
            if (typeof this.themeSoundsQueue[0] !== 'undefined') {
                this.playThemeSound(this.themeSoundsQueue[0].id);
            }
        });

        if (this.gameIsFinished) {
            fade(false);
            return;
        } else {
            fade(breakLoop);
            return;
        }
    }

    /**
     * Воспроизведение звуков темы из очереди
     */
    public playThemeSound(id: string): void
    {
        const sound: SoundObj|null = this.getSoundById(id);
        if (!sound || !this.themeSoundHolder) {
            return;
        }
        this.currentTheme = sound;
        this.themeIsLooping = sound.hasLoop as boolean;
        this.themeIsPlaying = true;
        const audio = this.themeSoundHolder as HTMLAudioElement;
        const audioSrc = SoundsContainer.getAudioSrc(sound.id);
        if (audioSrc && audio) {
            (audio as HTMLAudioElement).src = audioSrc;
        }
        if (this.themeIsLooping) {
            audio.volume = 0.3;
        } else if (id === 'mafiaEndGameCitizens') {
            audio.volume = 0.3;
        } else {
            audio.volume = 1;
        }
        const playPromise = audio.play();

        if (playPromise !== undefined) {
            playPromise.then(_ => {
                this.deleteThemeSoundFromQueue().then(() => {
                    if (this.themeSoundsQueue.length) {
                        this.playNextThemeSound();
                    }
                });
            })
            .catch(error => {
                console.warn(error);
            });
        }
    }

    /**
     * Воспроизвести звук
     * @param soundId
     * @param audio
     * @param breakFlag
     * @param isTable
     */
    public playSystemSound(soundId: string, audio: HTMLAudioElement | null, breakFlag: boolean, isTable?: boolean): void
    {
        if (!breakFlag || !audio) {
            return;
        }

        if (isTable) {
            this.allowSystemTableSound = false
        } else {
            this.allowSystemSound = false;
        }

        const audioSrc = SoundsContainer.getAudioSrc(soundId);
        if (!audioSrc) {
            return;
        }
        if (audioSrc && audio) {
            audio.src = audioSrc;
        }

        const playPromise = (audio as HTMLAudioElement).play();

        if (playPromise !== undefined) {
            playPromise.then(_ => {
                if (isTable) {
                    this.allowSystemTableSound = true
                } else {
                    this.allowSystemSound = true;
                }
            }).catch(error => {
                console.log(error);
            });
        }
    }

    /**
     * Истачник звука
     * @param soundId
     * @return {null|*}
     */
    private static getAudioSrc(soundId: string): string|null
    {
        let audioSrcMap = SoundsContainer.audioSrcMap;

        if (typeof audioSrcMap[soundId] !== "undefined") {
            return audioSrcMap[soundId];
        }

        return null;
    }

    /**
     * Карта звук - источник
     */
    private static get audioSrcMap(): {[key: string]: string}
    {
        return {
            // system sounds
            gameStart: '/audio/system/game-start.ogg',
            gameEnd: '/audio/system/game-end.ogg',
            voteStart: '/audio/system/voting-start.ogg',
            timerEnded: '/audio/system/bell.mp3',
            openSuggest: '/audio/system/suggest-open.ogg',
            openCatalog: '/audio/system/button-click.ogg',
            buttonClick: '/audio/system/button-click.ogg',
            playerComes: '/audio/system/guest-in.ogg',
            playerOut: '/audio/system/guest-out.ogg',
            dice: '/audio/system/dice.ogg',
            counterUp: '/audio/system/counter-up.ogg',
            counterDown: '/audio/system/counter-down.ogg',
            like: '/audio/system/like.ogg',
            dislike: '/audio/system/dislike.ogg',
            zoomTask: '/audio/system/zoom.ogg',
            clearChat: '/audio/system/clear-chat.ogg',
            error: '/audio/system/error.ogg',
            // table sounds
            itemMovedToTable: '/audio/table/add-to-table.ogg',
            itemTakeToHand: '/audio/table/add-to-hand.ogg',
            addToPile: '/audio/table/add-to-pile.ogg',
            itemSended: '/audio/table/deal-one-card.ogg',
            itemReceived: '/audio/table/deal-one-card.ogg',
            dealSeveralCards: '/audio/table/deal-several-cards.ogg',
            click: '/audio/table/click.ogg',
            flip: '/audio/table/flip.ogg',
            select: '/audio/table/select.ogg',
            zoom: '/audio/table/zoom.ogg',
            shuffle: '/audio/table/shuffle.ogg',
            itemLock: '/audio/table/lock.ogg',
            itemUnlock: '/audio/table/unlock.ogg',
            delete: '/audio/table/delete.ogg',
            zoomIn: '/audio/table/zoom-in.ogg',
            zoomOut: '/audio/table/zoom-out.ogg',
            // mafia sounds
            mafiaDayBegin: '/audio/mafia/dayBegin.ogg',
            mafiaDayLoop: '/audio/mafia/dayLoop.ogg',
            mafiaNightBegin: '/audio/mafia/nightBegin.ogg',
            mafiaNightLoop: '/audio/mafia/nightLoop.ogg',
            mafiaEndGameCitizens: '/audio/mafia/endGameCitizens.ogg',
            mafiaEndGameMafia: '/audio/mafia/endGameMafia.ogg',
            mafiaMafiaHit: '/audio/mafia/kill.ogg',
            mafiaCitizenExecuted: '/audio/mafia/execution.ogg',
            gameEndSimiloWin: '/audio/system/game-end.ogg',
            gameEndSimiloLoose: '/audio/system/dislike.ogg'
        };
    }
}

